import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { HomeState } from './index';

const initialState: HomeState = {
	popularLiveBettingData: [],
	bestSellerData: [],
	hotBannerData: [],
	bannerData: [],
	registrationBanners: {
		DESKTOP: undefined,
		MOBILE: undefined,
		SMALL_MOBILE: undefined,
		DESKTOP_V2: undefined,
		MOBILE_HEADER_V2: undefined,
		MOBILE_BACKGROUND_V2: undefined,
		VERIFICATION_DESKTOP: undefined,
		VERIFICATION_MOBILE_BACKGROUND: undefined,
	},
	isAlreadyData: false,
	sportEventImages: [],
	statScoreResponse: [],
	errorPlaceholder: false,
	oddsComparison: [],
};

export const homeReducer = (state: HomeState = initialState, action: Action): HomeState => {
	switch (action.type) {
		case actionTypes.FETCH_BESTSELLER_MATCHES_SUCCESS:
			return {
				...state,
				bestSellerData: action.payload.bestSellerData,
			};
		case actionTypes.FETCH_LIVE_BETTING_POPULAR_SUCCESS:
			return {
				...state,
				popularLiveBettingData: action.payload.popularLiveBettingData,
			};
		case actionTypes.SET_ODDS_COMPARISON:
			return { ...state, oddsComparison: [...action.payload.oddsComparison] };
		case actionTypes.FETCH_BESTSELLER_MATCHES_IS_ALREADY:
			return {
				...state,
				isAlreadyData: true,
			};
		case actionTypes.FETCH_BANNERS_SUCCESS:
			return {
				...state,
				bannerData: action.payload.subBannerData,
			};
		case actionTypes.FETCH_REGISTRATION_BANNERS_SUCCESS:
			return {
				...state,
				registrationBanners: action.payload.banners,
			};
		case actionTypes.FETCH_HOT_BANNERS_SUCCESS:
			return {
				...state,
				hotBannerData: action.payload.bannerData,
			};
		case actionTypes.FETCH_SPORT_EVENT_IMAGE:
			return {
				...state,
				sportEventImages: action.payload.sportEventImages,
			};
		case actionTypes.FETCH_STATSCORE_ID:
			return {
				...state,
				statScoreResponse: action.payload.statScoreResponse,
			};
		case actionTypes.LAYOUT_ERROR_PLACEHOLDER:
			return {
				...state,
				errorPlaceholder: action.payload.errorPlaceholder,
			};
		default:
			return state;
	}
};
